import { CheckboxGroup, CheckboxGroupProps } from "@heroui/react";
import {
  FilterCheckbox,
  FilterCheckboxProps,
} from "ds/ui/filter-checkbox/filter-checkbox";

export type CheckBoxGroupOption = Pick<
  FilterCheckboxProps,
  "value" | "label" | "avatar"
>;

export type FilterCheckboxGroupProps = Omit<CheckboxGroupProps, "children"> & {
  "aria-label": string;
  options: CheckBoxGroupOption[];
  value?: string[];
  ref?: React.Ref<HTMLDivElement>;
};

export function FilterCheckboxGroup({
  ref,
  ...props
}: FilterCheckboxGroupProps) {
  const { options, ...rest } = props;
  return (
    <CheckboxGroup {...rest} ref={ref}>
      {options.map((opt) => (
        <FilterCheckbox
          key={opt.value}
          avatar={opt.avatar}
          label={opt.label}
          value={opt.value}
        />
      ))}
    </CheckboxGroup>
  );
}

FilterCheckboxGroup.displayName = "RecareUI.FilterCheckboxGroup";
